const FILTER_STORAGE_TYPES = Object.freeze({
  LOCAL: 'local',
  SESSION: 'session',
  NONE: 'none',
});

export const FILTER_SCOPES = Object.freeze({
  TODOS_OVERVIEW: 'todos_overview',
  TODOS_LEVEL: 'todos_level',
});

export default FILTER_STORAGE_TYPES;
